<template>
    <b-card v-if="this.content">
        <b-card-body>
            <b-row>
                <b-col cols="2">
                    <label>Typ:</label><br />
                    <lformselect v-model="content.ConsolidationType" :options="consolidationOptions" :readonly="readonly">
                    </lformselect>
                </b-col>
               
                <b-col>
                    <label>Beskrivning:</label><br />
                    <b-form-input v-model="content.Description" :readonly="readonly"></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="2">Filter:</b-col>
                <b-col>
                    <!-- <lformselect class="form-control" v-model="content.BookingFilter" :options="colliFilterTypes"
                        :readonly="readonly">
                    </lformselect> -->
                    <filtereditor v-model="content.BookingFilter" :readonly="readonly"></filtereditor>
                    <!-- {{ content.BookingFilter }} -->
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="2">
                    <lformcheck :readonly="readonly" :value="IsActive(content.ConsolidationKeyTemplate)"
                        @change="ActivateValue($event, 'ConsolidationKeyTemplate')"></lformcheck> Konsolideringsnyckel
                </b-col>
                <b-col>
                    <lformselect class="form-control" v-model="content.ConsolidationKeyTemplate"
                        :options="consolidationKeyTemplates" v-if="IsActive(content.ConsolidationKeyTemplate)"
                        :readonly="readonly">
                    </lformselect>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="2">
                    <lformcheck :readonly="readonly" :value="IsActive(content.EarliestRelease)"
                        @change="ActivateValue($event, 'EarliestRelease')"></lformcheck> Konsolidering tidigast
                </b-col>
                <b-col>
                    <lformselect class="form-control" v-model="content.EarliestRelease" :options="earliestReleaseTimes"
                        v-if="IsActive(content.EarliestRelease)" :readonly="readonly">
                    </lformselect>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="2">
                    <lformcheck :readonly="readonly" :value="IsActive(content.LatestRelease)"
                        @change="ActivateValue($event, 'LatestRelease')"></lformcheck> Konsolidering senast
                </b-col>
                <b-col>
                    <lformselect class="form-control" v-model="content.LatestRelease" :options="earliestReleaseTimes"
                        v-if="IsActive(content.LatestRelease)" :readonly="readonly">
                    </lformselect>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="2">
                    <lformcheck :readonly="readonly" :value="IsActive(content.ContactEmail)"
                        @change="ActivateValue($event, 'ContactEmail')"></lformcheck> Email
                </b-col>
                <b-col>
                    <b-form-input v-if="IsActive(content.ContactEmail)" v-model="content.ContactEmail"
                        @input="TriggerChange()" :readonly="readonly"></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="2">
                    <lformcheck :readonly="readonly" :value="IsActive(content.ContactPhone)"
                        @change="ActivateValue($event, 'ContactPhone')"></lformcheck> Telefon
                    <!-- <b-checkbox :checked="IsActive(content.ContactPhone)"
                        @change="ActivateValue($event, 'ContactPhone')">
                        Telefon</b-checkbox> -->
                </b-col>
                <b-col>
                    <b-form-input v-if="IsActive(content.ContactPhone)" v-model="content.ContactPhone"
                        :readonly="readonly"></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="2">
                    <lformcheck :readonly="readonly" :value="IsActive(content.ServiceTypeId)"
                        @change="ActivateValue($event, 'ServiceTypeId')"></lformcheck> Transporttyp
                    <!-- <b-checkbox :checked="IsActive(content.ServiceTypeId)"
                        @change="ActivateValue($event, 'ServiceTypeId')">
                        Transporttyp</b-checkbox> -->
                </b-col>
                <b-col>
                    <!-- <b-form-input v-if="IsActive(content.ServiceTypeId)" v-model="content.ServiceTypeId"
                        :readonly="readonly"></b-form-input> -->
                    <lformselect class="form-control" v-if="IsActive(content.ServiceTypeId)" v-model="content.ServiceTypeId"
                        :options="GetServiceTypes()" :readonly="readonly">
                    </lformselect>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="2">
                    <lformcheck :readonly="readonly" :value="IsActive(content.TerminalName)"
                        @change="ActivateValue($event, 'TerminalName')"></lformcheck> Terminal
                    <!--                     
                    <b-checkbox :checked="IsActive(content.TerminalName)"
                        @change="ActivateValue($event, 'TerminalName')">
                        Terminal</b-checkbox> -->
                </b-col>
                <b-col>
                    <!-- <b-form-input v-if="IsActive(content.TerminalName)" v-model="content.TerminalName"
                        :readonly="readonly"></b-form-input> -->
                    <lformselect class="form-control" v-if="IsActive(content.TerminalName)" v-model="content.TerminalName"
                        :options="GetTerminals()" :readonly="readonly">
                    </lformselect>
                </b-col>
            </b-row>

            <stepinput title="Hämtadress (Terminalnamn)" v-model="content.PickupTerminalName" :type="'select'" :options="GetAddresses()" :readonly="readonly" @input="TriggerChange()"></stepinput>            

            <stepinput title="Hämtadress.Namn" v-model="content.PickupPlaceName" :readonly="readonly" @input="TriggerChange()"></stepinput>
            <stepinput title="Hämtadress.Adress1" v-model="content.PickupPlaceStreet" :readonly="readonly" @input="TriggerChange()"></stepinput>
            <stepinput title="Hämtadress.Adress2" v-model="content.PickupPlaceStreet2" :readonly="readonly" @input="TriggerChange()"></stepinput>
            <stepinput title="Hämtadress.Postnr" v-model="content.PickupPlacePostCode" :readonly="readonly" @input="TriggerChange()"></stepinput>
            <stepinput title="Hämtadress.Ort" v-model="content.PickupPlaceCity" :readonly="readonly" @input="TriggerChange()"></stepinput>
            
            <stepinput title="Leveransadress (Terminalnamn)" v-model="content.DeliveryTerminalName" :type="'select'" :options="GetAddresses()" :readonly="readonly" @input="TriggerChange()"></stepinput>            

            <stepinput title="Leveransadress.Namn" v-model="content.DeliveryPlaceName" :readonly="readonly" @input="TriggerChange()"></stepinput>
            <stepinput title="Leveransadress.Adress1" v-model="content.DeliveryPlaceStreet" :readonly="readonly" @input="TriggerChange()"></stepinput>
            <stepinput title="Leveransadress.Adress2" v-model="content.DeliveryPlaceStreet2" :readonly="readonly" @input="TriggerChange()"></stepinput>
            <stepinput title="Leveransadress.Postnr" v-model="content.DeliveryPlacePostCode" :readonly="readonly" @input="TriggerChange()"></stepinput>
            <stepinput title="Leveransadress.Ort" v-model="content.DeliveryPlaceCity" :readonly="readonly" @input="TriggerChange()"></stepinput>
            
            <stepinput title="Produkt" v-model="content.ProductKey" :type="'select'" :options="GetProducts()" :readonly="readonly" @input="TriggerChange()"></stepinput>            
            <stepinput title="Transportör" v-model="content.TransporterName" :type="'select'" :options="GetTransporterNames()" :readonly="readonly" @input="TriggerChange()"></stepinput>
            <b-row>
                <b-col cols="2">
                    <lformcheck :readonly="readonly" :value="IsActive(content.DeliveryDateOffset)"
                        @change="ActivateValue($event, 'DeliveryDateOffset')"></lformcheck> Extra Leveransdagar
                    <!-- <b-checkbox :checked="IsActive(content.TourName)" @change="ActivateValue($event, 'TourName')">
                        Tur</b-checkbox> -->
                </b-col>
                <b-col>
                    <b-form-input type="number" v-if="IsActive(content.DeliveryDateOffset)"
                        v-model="content.DeliveryDateOffset" :readonly="readonly">
                    </b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="2">
                    <lformcheck :readonly="readonly" :value="IsActive(content.TourName)"
                        @change="ActivateValue($event, 'TourName')"></lformcheck> Tur
                    <!-- <b-checkbox :checked="IsActive(content.TourName)" @change="ActivateValue($event, 'TourName')">
                        Tur</b-checkbox> -->
                </b-col>
                <b-col>
                    <b-form-input v-if="IsActive(content.TourName)" v-model="content.TourName" :readonly="readonly">
                    </b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="2">
                    <lformcheck :readonly="readonly" :value="IsActive(content.StatusId)"
                        @change="ActivateValue($event, 'StatusId')"></lformcheck> StatusId

                    <!-- <b-checkbox :checked="IsActive(content.StatusId)" @change="ActivateValue($event, 'StatusId')">
                        StatusId</b-checkbox> -->
                </b-col>
                <b-col>
                    <!-- <b-form-input v-if="IsActive(content.StatusId)" v-model="content.StatusId" :readonly="readonly">
                    </b-form-input> -->
                    <lformselect class="form-control" v-if="IsActive(content.ServiceTypeId)" v-model="content.StatusId"
                        :options="GetStatusIds()" :readonly="readonly">
                    </lformselect>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-card>
                        <b-card-header>Kollin <b-button size="sm" @click="AddColli()" v-if="!readonly"
                                title="Lägg till kolli">+</b-button></b-card-header>
                        <b-card-body>
                            <b-row>
                                <b-col><b>Bokningsfilter</b></b-col>
                                <b-col><b>Kollityp</b></b-col>
                                <b-col></b-col>
                            </b-row>
                            <b-row v-for="(c, i) in content.Collis" :key="i">

                                <b-col>
                                    <!-- <b-form-input v-model="c.Filter" :readonly="readonly">                                                                    </b-form-input> -->
                                    <!-- <lformselect class="form-control" v-model="c.Filter" :options="colliFilterTypes"
                                        :readonly="readonly">
                                    </lformselect>
                                     -->
                                     <filtereditor v-model="c.Filter" :readonly="readonly"></filtereditor>
                                </b-col>
                                <b-col>
                                    <!-- <b-form-input v-model="c.ColliSelectionType"></b-form-input> -->
                                    <lformselect class="form-control" v-model="c.ColliSelectionType"
                                        :options="colliTypeOptions" :readonly="readonly">
                                    </lformselect>
                                </b-col>
                                <b-col><b-button size="sm" v-if="!readonly" @click="RemoveColli(c)">Ta
                                        bort</b-button></b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import lformselect from "@/components/l-form-select.vue"
import lformcheck from "@/components/l-form-check.vue"
import filtereditor from './filtereditor.vue';
import stepinput from './stepinput.vue';

export default {
    name: 'consolidationroutestep',
    components: { lformselect, lformcheck, filtereditor,stepinput },
    props: { value: Object, readonly: Boolean, basics: Object },
    data() {
        return {
            content: this.value,
            consolidationOptions: [
                { value: null, text: '(Välj typ)' },
                { value: '*', text: 'Distribuerad' },
                { value: '1', text: 'Samlad' }
            ],
            colliTypeOptions: [
                { value: 'LC', text: 'Lastbärare+Blandburar' },
                { value: 'SC', text: 'Underkollin' },
                { value: 'AC', text: 'Odelade kollin' },
                { value: 'LC+AC', text: 'Lastbärare+Blandburar och odelade kollin' },
                { value: 'AC+SC', text: 'Underkollin och odelade kollin' },
                { value: 'LC!M+AC+SCM', text: 'Lastbärare (ej blandburar), odelade kollin, underkollin blandburar' }
            ],
            colliFilterTypes: [
                { value: '', text: '(ALLA)' },
                { value: 'ServiceTypeId!=50', text: 'Övriga, ej butiksorder' },
                { value: 'ServiceTypeId==50', text: 'Butiksorder' },
            ],
            consolidationKeyTemplates: [
                { value: '', text: '(Ingen)' },
                { value: '{0}_1', text: 'Special 1' },
                { value: '{0}_2', text: 'Special 2' },
                { value: '{0}_2', text: 'Special 3' },
                { value: '{0}|{2}', text: 'Per kundnr' },
            ],
            earliestReleaseTimes: [],
        }
    },
    created() {
        var mins = ['00', '15', '30', '45'];
        var res = [];
        for (var d = -1; d <= 0; d++)
            for (var h = 0; h < 24; h++)
                mins.map(m => res.push({ value: `${d},${h}:${m}`, text: `(Leveransdag ${d}) ${h}:${m}` }));

        this.earliestReleaseTimes = res;
    },
    methods: {
        // oninput(e) {
        //     this.$emit('input', this.content);
        // },

        IsActive(v) {
            return !(v === null || v === undefined);
        },
        ActivateValue(e, field) {
            console.log(e);
            if (e) {
                this.content[field] = '';
            } else {
                this.content[field] = null;
            }
            this.TriggerChange();
            this.$forceUpdate();
            //this.oninput(e);
        },
        GetTerminals: function () {
            return (!this.basics) ? [] :
                this.basics.terminals
                    .map(x => { return { "value": x.terminalName, "text": x.terminalName } })
                    .sort((a, b) => a.text.localeCompare(b.text));
        },
        GetAddresses: function () {
            let terms = this.GetTerminals();
            terms.push({"value":"?", "text": "(Terminaladress)"});

            return terms;
        },
        GetStatusIds: function () {
            return !this.basics ? [] :
                this.basics.status.map((x) => { return { "value": x.StatusId, "text": x.BookingStatusName } });
        },
        GetServiceTypes: function () {
            return !this.basics ? [] :
                this.basics.serviceTypes.map((x) => { return { "value": x.ServiceTypeId, "text": x.Name } });
        },
        // GetColliFilterTypes: function () {
        //     var res = this.GetServiceTypes();
        //     //res.unshift({ "value": "", text: "(ALLA)" });

        //     return res;
        // },
        GetProducts: function () {
            return !this.basics ? [] :
                this.basics.products.map((x) => { return { "value": x.ProductKey, "text": `${x.TransporterName}-${x.PrettyName}` } });
        },
        GetTransporterNames: function () {
            if (this.basics) {
                var uniqueNames = [...new Set(this.basics.products.map(x => x.TransporterName))];
                return uniqueNames.map(x => { return { "value": x, "text": x } });
            }

            return [];
        },
        GetCollis() {
            if (this.content && this.content.Collis)
                return this.content.Collis;
            return [];
        },
        AddColli() {
            if (!this.content.Collis)
                this.content.Collis = [];
            this.content.Collis.push({ "ColliSelectionType": "LC+AC", "Filter": "" });
            this.TriggerChange();
            this.$forceUpdate();
        },
        RemoveColli(c) {
            this.content.Collis = this.content.Collis.filter(x => x !== c);
            this.TriggerChange();
            this.$forceUpdate();
        },
        TriggerChange() {
            this.$emit('input', this.content);
        }
    }

}

</script>